import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./authProvider";

const RequireGuest = () => {
    const { isLoggedIn, isLoading } = useAuth();

    if (isLoading) return null;

    if (isLoggedIn){
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default RequireGuest;